<template>
  <div class="policy-wrap" v-if="termsData !== null">
    <div class="policy-date">시행일자 {{termsData.effectivedate}}</div>
    <div class="policy-desc" v-html="termsData.content"></div>

    <div class="filter-item-select">
      <label>
        <select v-model="selectedVersion" v-if="filterList.length > 0" :disabled="filterList.length === 1">
          <option v-for="(filter, index) in filterList" :key="index" :value="filter.version">{{filter.text}}</option>
        </select>
      </label>
    </div>
  </div>
</template>

<script>
import { AgreementService } from '@/common/api/api.service'
import { PATH_NAME_PAID, PATH_NAME_POOQZONE_VOUCHER } from '@/common/router.const'
import { get, findIndex } from 'lodash'
export default {
  name: 'CommonAgreement',
  components: {},
  data () {
    return {
      termsData: null,
      version: 'last',
      filterList: [],
      selectedVersion: ''
    }
  },
  methods: {
    getType () {
      if (this.$route.name === PATH_NAME_PAID) {
        return 'payment'
      } else if (this.$route.name === PATH_NAME_POOQZONE_VOUCHER) {
        return 'pooqzone'
      } else {
        return this.$route.name
      }
    },
    getAgreementVersion (termVersion) {
      this.version = termVersion
      this.setAgreementData()
    },
    setAgreementData () {
      AgreementService.getTerms({
        type: this.getType(),
        version: this.version
      }).then(({ data }) => {
        this.termsData = data
        this.filterList = get(this.termsData, 'list', [])
        const selectedFilterIndex = findIndex(this.filterList, { version: get(this.termsData, 'version', 'last') })
        this.selectedVersion = get(this.filterList, [selectedFilterIndex, 'version'], 'last')
        this.$nextTick(() => {
          window.scrollTo(0, 0)
        })
      })
    }
  },
  created () {
    this.setAgreementData()
  },
  watch: {
    selectedVersion (newVersion) {
      this.getAgreementVersion(newVersion)
    }
  }
}
</script>

<style scoped>
  .filter-item-select{
    padding: 0 15px;
    font-size: 0;
    text-align: center;
  }

  .filter-item-select label{
    display: inline-block;
    padding: 7px 0;
  }

  .filter-item-select select {
    -webkit-appearance: none; /* 네이티브 외형 감추기 */
    -moz-appearance: none;
    appearance: none;
    padding-right: 16px;
    border: none;
    font-size: 14px;
    line-height: 20px;
    vertical-align: middle;
    color: #fff;
    background-image: url(../../assets/images/icon-12-12-ic-open-w@3x.png);
    background-repeat: no-repeat;
    background-position: center right;
    background-size: 12px;
    background-color: #1b1b1b;
  }

  .play-menu-container .filter-item-select select {
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
    background-color: #1b1b1b;
  }

  .filter-item-select select:focus {
    outline: none;
  }

  .filter-item-select option {
    direction: ltr;
  }

 .policy-date{
   padding: 0 15px;
   height: 44px;
   line-height: 44px;
   font-size: 12px;
   color: #a5a5a5;
   border-bottom: 1px solid #2f2f2f;
 }
 .policy-desc {
   font-size: 13px;
   line-height: 22px;
   color: #a5a5a5;
   padding: 15px 15px 50px;
 }
 .policy-desc >>> table{
   width: 100%;
   word-break: break-all;
 }
 .policy-desc >>> th{
   width: 140px;
   text-align: center;
   padding: 14px 0;
   border: 1px solid #dedede;
 }
 .policy-desc >>> td{
   padding: 14px 20px;
   border: 1px solid #dedede;
   color: #a5a5a5;
 }
 .policy-wrap {
   width: 100%;
   padding-bottom: 30px;
 }
 .policy-wrap::-webkit-scrollbar{
   display: none;
   background-color: transparent;
 }
 .policy-btn {
   padding-left: 10px;
 }
 .policy-btn a {
   display: block;
   width: 100%;
   height: 30px;
   padding: 0 12px;
   border-radius: 100px;
   border: 1px solid #d9d9d9;
   font-size: 0;
   line-height: 28px;
   text-align: center;
   color: #fff;
 }
 .policy-btn a img,
 .policy-btn a span{
   display: inline-block;
   font-size: 12px;
   vertical-align: middle;
 }
 .policy-btn a img{
   width: 12px;
   height: 12px;
 }
 .policy-btn a img + span,
 .policy-btn a span + img{
   margin-left: 3px;
 }
 .policy-btn ul::after{
   content: '';
   display: table;
   clear: both;
 }
 .policy-btn li {
   float: left;
   text-align: center;
 }

 .policy-btn li.now-policy{
   float: right;
 }
</style>
